import React, { useState } from "react";
// ** Cutome Component
import Breadcrumbs from "@components/breadcrumbs";
// ** ReactStrap
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import EditorsMaster from "./EditorsMaster";
import EditorsList from "./EditorsList";

// ** Components

const EditorsMasterTabs = () => {
  const [active, setActive] = useState("1");

  const toggle = (item) => {
    setActive(item);
  };
  return (
    <div>
      <Breadcrumbs
        title="Editors Master"
        data={[{ title: "Editors Master", link: "" }]}
      />
      <Nav tabs>
        <NavItem>
          <NavLink
            className="for-client-table"
            active={active === "1"}
            onClick={() => {
              toggle("1");
            }}
          >
            List of Default Editors
          </NavLink>
        </NavItem>

        <NavItem>
          <NavLink
            className="for-client-table"
            active={active === "2"}
            onClick={() => {
              toggle("2");
            }}
          >
            List of Editors
          </NavLink>
        </NavItem>
      </Nav>
      <TabContent className="py-50" activeTab={active}>
        <TabPane tabId="1">{active === "1" && <EditorsMaster />}</TabPane>
        <TabPane tabId="2">{active === "2" && <EditorsList />}</TabPane>
      </TabContent>
    </div>
  );
};

export default EditorsMasterTabs;
